export {default as PeopleToContact} from './PeopleToContact.connect';
